const state = {
  socket: {
    isConnected: false,
    message: '',
    reconnectError: '',
    event: null,
    timer: null
  }
}

export default state
